import { UserManager } from "oidc-client";
import { storeUserError } from "../actions/authActions";
import { setUser } from "../redux/slice/auth";

const config = {
  authority: process.env.REACT_APP_AUTHORITY,
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  response_type: process.env.REACT_APP_RESPONSE_TYPE,
  scope: process.env.REACT_APP_SCOPE,
  post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
  automaticSilentRenew: true,
  monitorSession: true,
  loadUserInfo: true,
};

const userManager = new UserManager(config);

export async function loadUserFromStorage(store) {
  try {
    const user = await userManager.getUser();
    if (!user) {
      return store.dispatch(storeUserError());
    } else {
      store.dispatch(setUser(user));
    }
  } catch (e) {
    console.error(`User not found: ${e}`);
    return store.dispatch(storeUserError());
  }
}

export function signinRedirect() {
  return userManager.signinRedirect({
    extraQueryParams: { companyId: process.env.REACT_APP_COMPANY_ID },
  });
}

export function signinRedirectCallback() {
  return userManager.signinRedirectCallback();
}

export function signoutRedirect() {
  userManager.clearStaleState();
  userManager.removeUser();
  localStorage.removeItem("profile");
  localStorage.removeItem("userAccess");
  localStorage.removeItem("abilityList");
  const userToken = localStorage.getItem("idToken");
  return userManager.signoutRedirect({
    id_token_hint: userToken,
    post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
  });
}

export function signoutRedirectCallback() {
  userManager.clearStaleState();
  userManager.removeUser();
  return userManager.signoutRedirectCallback();
}

export default userManager;
